import styled from 'styled-components/macro';
import { Button, ButtonProps } from 'antd';
import { ButtonSize, buttonSizesMapper, ButtonType, buttonTypesMapper, ITAButtonProps } from '../index';

const DEFAULT_BTN_SIZE = ButtonSize.SMALL;
const DEFAULT_BTN_TYPE = ButtonType.PRIMARY;

export const TAButton = styled(Button)<ITAButtonProps & ButtonProps>`
	height: ${({ btnSize = DEFAULT_BTN_SIZE }) => buttonSizesMapper[btnSize].height};
	width: ${({ width = 'auto' }) => width};
	outline: none;
	display: flex;
	align-items: center;
	justify-content: center;

	background-color: ${({ theme, btntype = DEFAULT_BTN_TYPE }) =>
		buttonTypesMapper(theme)[btntype].default.backgroundColor};
	border: ${({ theme, btntype = DEFAULT_BTN_TYPE }) =>
		`1px solid ${buttonTypesMapper(theme)[btntype].default.borderColor}`};
	font-size: ${({ theme, btntype = DEFAULT_BTN_TYPE }) => buttonTypesMapper(theme)[btntype].default.text.size};
	font-weight: 500;
	color: ${({ theme, btntype = DEFAULT_BTN_TYPE }) => buttonTypesMapper(theme)[btntype].default.text.color};
	line-height: ${({ theme, btntype = DEFAULT_BTN_TYPE }) =>
		buttonTypesMapper(theme)[btntype].default.text.lineHeight};

	transition: background-color 0.2s;

	&:hover,
	&:focus {
		background-color: ${({ theme, btntype = DEFAULT_BTN_TYPE }) =>
			buttonTypesMapper(theme)[btntype].hover.backgroundColor};
		border: ${({ theme, btntype = DEFAULT_BTN_TYPE }) =>
			`1px solid ${buttonTypesMapper(theme)[btntype].hover.borderColor}`};
		font-size: ${({ theme, btntype = DEFAULT_BTN_TYPE }) => buttonTypesMapper(theme)[btntype].hover.text.size};
		color: ${({ theme, btntype = DEFAULT_BTN_TYPE }) =>
			buttonTypesMapper(theme)[btntype].hover.text.color} !important;
		line-height: ${({ theme, btntype = DEFAULT_BTN_TYPE }) =>
			buttonTypesMapper(theme)[btntype].hover.text.lineHeight};
	}

	&:active {
		background-color: ${({ theme, btntype = DEFAULT_BTN_TYPE }) =>
			buttonTypesMapper(theme)[btntype].pressed.backgroundColor};
		border: ${({ theme, btntype = DEFAULT_BTN_TYPE }) =>
			`1px solid ${buttonTypesMapper(theme)[btntype].pressed.borderColor}`};
		font-size: ${({ theme, btntype = DEFAULT_BTN_TYPE }) => buttonTypesMapper(theme)[btntype].pressed.text.size};
		color: ${({ theme, btntype = DEFAULT_BTN_TYPE }) => buttonTypesMapper(theme)[btntype].pressed.text.color};
		line-height: ${({ theme, btntype = DEFAULT_BTN_TYPE }) =>
			buttonTypesMapper(theme)[btntype].pressed.text.lineHeight};
	}

	&:disabled,
	&:disabled:hover {
		background-color: ${({ theme, btntype = DEFAULT_BTN_TYPE }) =>
			buttonTypesMapper(theme)[btntype].disabled.backgroundColor};
		border: ${({ theme, btntype = DEFAULT_BTN_TYPE }) =>
			`1px solid ${buttonTypesMapper(theme)[btntype].disabled.borderColor}`};
		font-size: ${({ theme, btntype = DEFAULT_BTN_TYPE }) => buttonTypesMapper(theme)[btntype].disabled.text.size};
		color: ${({ theme, btntype = DEFAULT_BTN_TYPE }) => buttonTypesMapper(theme)[btntype].disabled.text.color};
		line-height: ${({ theme, btntype = DEFAULT_BTN_TYPE }) =>
			buttonTypesMapper(theme)[btntype].disabled.text.lineHeight};
	}
`;
